// extracted by mini-css-extract-plugin
export var actions = "_a3-8";
export var arrow = "_a3-5";
export var card = "_a3-0";
export var cardWrapper = "_a3-9";
export var fieldName = "_a3-3";
export var newValue = "_a3-6";
export var oldValue = "_a3-4";
export var orangeGlowFade = "_a3-c";
export var productSection = "_a3-1";
export var scrollToBottom = "_a3-b";
export var scrollToBottomAnchor = "_a3-a";
export var scrollToBottomIcon = "_a3-d";
export var showAllButton = "_a3-7";
export var table = "_a3-2";